/**
 * Shared UI module for SMG
 */
(function() {
  angular.module('smg.ui', [
    'ui.bootstrap',
    'ui.select',
    'ui.checkbox'
  ])

  .config([
    'uiSelectConfig', '$uibTooltipProvider',
    function(uiSelectConfig, $uibTooltipProvider) {
      uiSelectConfig.theme = 'select2';

      $uibTooltipProvider.options({
        popupDelay: 800
      });
    }
  ])

  .directive('smgIgnoreDirty', [
    function() {
      return {
        restrict: 'AC',
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
          ngModel.$setPristine = angular.noop;
          ngModel.$pristine = false;
          ngModel.$setDirty = angular.noop;
          ngModel.$dirty = true;
        }
      };
    }
  ]);
}).call(this);
